// extracted by mini-css-extract-plugin
export default {"tab":"bX8mBc","active":"yzjKGu","active-gold-50":"ba9Vd7","active-white":"OA7iVx"};